<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton
        class="flex hover:opacity-80 items-center transition-all duration-200 justify-center mt-8 md:mt-6 font-medium md:text-[16px] text-big-body md:justify-start text-brand-blue"
      >
        <svg
          class="mr-2"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.25 3C4.46403 3 3 4.46403 3 6.25V17.75C3 19.536 4.46403 21 6.25 21H17.75C19.536 21 21 19.536 21 17.75V6.25C21 4.46403 19.536 3 17.75 3H6.25ZM6.25 4.5H17.75C18.725 4.5 19.5 5.27497 19.5 6.25V7H4.5V6.25C4.5 5.27497 5.27497 4.5 6.25 4.5ZM4.5 8.5H19.5V17.75C19.5 18.725 18.725 19.5 17.75 19.5H6.25C5.27497 19.5 4.5 18.725 4.5 17.75V8.5ZM13.75 12C12.7925 12 12 12.7925 12 13.75V15.75C12 16.7075 12.7925 17.5 13.75 17.5H15.75C16.7075 17.5 17.5 16.7075 17.5 15.75V13.75C17.5 12.7925 16.7075 12 15.75 12H13.75ZM13.75 13.5H15.75C15.8975 13.5 16 13.6025 16 13.75V15.75C16 15.8975 15.8975 16 15.75 16H13.75C13.6025 16 13.5 15.8975 13.5 15.75V13.75C13.5 13.6025 13.6025 13.5 13.75 13.5Z"
            fill="#2699C6"
          />
        </svg>

        <span> Uložit do kalendáře</span>
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute left-0 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div v-for="(calendar, i) in calendars" :key="i">
          <MenuItem vof v-slot="{ active }">
            <a
              :href="calendar.link"
              :class="[
                active ? ' text-white' : 'text-gray-900',
                'group flex w-full  font-medium hover:text-gray-600 items-center rounded-md px-2 py-2.5 text-sm',
              ]"
            >
              {{ calendar.name }}
            </a>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { useMetadataStore } from "../stores/metadata";
import { computed, onMounted } from "vue";
const metadataStore = useMetadataStore();

onMounted(() => {
  console.log(metadataStore.metadata);
});

const calendars = computed(() => {
  return [
    {
      name: "Google",
      link: metadataStore.metadata.google_calendar_invitation_link.url,
    },
    {
      name: "Apple",
      link: metadataStore.metadata.apple_calendar_invitation_link.url,
    },
    {
      name: "Office 365",
      link: metadataStore.metadata.office365_calendar_invitation_link.url,
    },
  ];
});
</script>
